// The only way the web app talks to the backend: the shared services (@lista/app-core)
// over this app's configured client (cookie refresh, in-memory token).
import { createServices } from '@lista/app-core';
import { api } from './client';

export { api, refreshSession, setSessionExpiredHandler, tryRefresh } from './client';
export { API_BASE_URL } from './config';
export {
  ApiError,
  errorCode,
  errorStatus,
  fieldErrors,
  isApiError,
  isNetworkError,
  NetworkError,
  queryKeys,
  type DashboardFilters,
  type MembersOverview,
  type Page,
  type PdfOptions,
  type SearchParams,
} from '@lista/app-core';
export { exportService } from './services/export';

export const services = createServices(api);
export const {
  auth: authService,
  users: usersService,
  lists: listsService,
  listItems: listItemsService,
  catalog: catalogService,
  favorites: favoritesService,
  sharing: sharingService,
} = services;
